const ANALYTICS_UPDATE_DIGITAL_DATA = 'ANALYTICS_UPDATE_DIGITAL_DATA'
const ANALYTICS_UPDATE_USER_INFO = 'ANALYTICS_UPDATE_USER_INFO'
const ANALYTICS_GET_PAGE_HEAD_ANALYTICS = 'ANALYTICS_GET_PAGE_HEAD_ANALYTICS'
const ANALYTICS_DO_TRACK = 'ANALYTICS_DO_TRACK'
const ANALYTICS_PUSH_EVENT_AND_TRACK = 'ANALYTICS_PUSH_EVENT_AND_TRACK'
const ANALYTICS_PUSH_RECOMMENDATION = 'ANALYTICS_PUSH_RECOMMENDATION'
const ANALYTICS_PUSH_PRODUCT_CARE_LIGHTBOX = 'ANALYTICS_PUSH_PRODUCT_CARE_LIGHTBOX'
const ANALYTICS_CLEAR_PRODUCT_CARE_LIGHTBOX = 'ANALYTICS_CLEAR_PRODUCT_CARE_LIGHTBOX'
const ANALYTICS_HANDLE_ADD_PRODUCT_TO_OFFER = 'ANALYTICS_HANDLE_ADD_PRODUCT_TO_OFFER'
const ANALYTICS_HANDLE_CHANGE_PAGE_FOR_STEP = 'ANALYTICS_HANDLE_CHANGE_PAGE_FOR_STEP'
const ANALYTICS_HANDLE_CHANGE_PRODUCT_IN_STEP = 'ANALYTICS_HANDLE_CHANGE_PRODUCT_IN_STEP'
const ANALYTICS_HANDLE_ANALYTICS_SET_UP = 'ANALYTICS_HANDLE_ANALYTICS_SET_UP'
const ANALYTICS_PUSH_AR3D_IN_PAGE = 'ANALYTICS_PUSH_AR3D_IN_PAGE'

export {
  ANALYTICS_UPDATE_DIGITAL_DATA,
  ANALYTICS_UPDATE_USER_INFO,
  ANALYTICS_GET_PAGE_HEAD_ANALYTICS,
  ANALYTICS_DO_TRACK,
  ANALYTICS_PUSH_EVENT_AND_TRACK,
  ANALYTICS_PUSH_RECOMMENDATION,
  ANALYTICS_PUSH_PRODUCT_CARE_LIGHTBOX,
  ANALYTICS_CLEAR_PRODUCT_CARE_LIGHTBOX,
  ANALYTICS_HANDLE_ADD_PRODUCT_TO_OFFER,
  ANALYTICS_HANDLE_CHANGE_PAGE_FOR_STEP,
  ANALYTICS_HANDLE_CHANGE_PRODUCT_IN_STEP,
  ANALYTICS_HANDLE_ANALYTICS_SET_UP,
  ANALYTICS_PUSH_AR3D_IN_PAGE
}
